import React, { useMemo } from "react";
import { useEvaluatedFeatureFlags } from "../query-hooks/useFeatureFlags";
import {
    FeatureFlagContext,
    type FeatureFlagContextValue,
} from "../contexts/FeatureFlagContext";

export function FeatureFlagProvider({
    children,
}: Readonly<{ children: React.ReactNode }>) {
    const { data, isLoading } = useEvaluatedFeatureFlags();

    const value = useMemo<FeatureFlagContextValue>(() => {
        const flags = data?.result ?? {};
        return {
            flags,
            hasFlag: (key: string) => flags[key],
            isLoading,
        };
    }, [data?.result, isLoading]);

    return (
        <FeatureFlagContext.Provider value={value}>
            {children}
        </FeatureFlagContext.Provider>
    );
}
